import { render, staticRenderFns } from "./EhsDetails.vue?vue&type=template&id=3198cda1"
import script from "./EhsDetails.vue?vue&type=script&lang=js"
export * from "./EhsDetails.vue?vue&type=script&lang=js"
import style0 from "./EhsDetails.vue?vue&type=style&index=0&id=3198cda1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports